export default __webpack_public_path__ + "static/media/arrow-prev.e98651f6.svg";